<template>
	<div class="login">
		<div class="login-logo">
			<a href="/">
				<img src="../assets/logo4.png" />
			</a>
		</div>
		<div class="container">
			<h3>欢迎使用</h3>
			<div class="content-wrapper">
				<div class="form-title">CloudLinker 密码修改</div>
				<el-form class="resetPassword-ruleForm" :model="formData" ref="passForm" :rules="rules">
					<div class="list-group">
						<el-form-item class="list-group-item" prop="pass">
							<el-input type="password" v-model.trim="formData.pass" auto-complete="off" placeholder="密码"> </el-input>
							<p style="margin-top: 10px;" v-show="show_password_warning && company_password_strength == 1">
								<translate>The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.</translate>
							</p>
							<p style="margin-top: 10px;"  v-show="show_password_warning && company_password_strength == 2">
								<translate>The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.</translate>
							</p>
						</el-form-item>

						<el-form-item class="list-group-item" prop="checkPass">
							<el-input type="password" v-model="formData.checkPass" auto-complete="off" placeholder="重复密码"> </el-input>
						</el-form-item>
					</div>
					<el-form-item>
						<el-button @click="onSubmitForm('passForm')" class="btn" :disabled="formData.pass != '' && formData.checkPass != '' ? false : true">
							<span v-if="!loading">登录</span>
							<span v-if="loading">
								<span>登录中</span>
								<i class="el-icon-loading"></i>
							</span>
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="copyright clearfix small">
			<div>Copyright 上海驻云信息科技有限公司</div>
			<div>
				Powered by
				<a href="https://www.cloudcare.cn" target="_blank" class="text-primary new-block">cloudcare.cn</a>
			</div>
		</div>
	</div>
</template>
<script>
import STORE_CONST from '../store/consts'
import { PasswordStrengthRegExp, PasswordStrengthRegExpCallback } from '../config'
export default {
	name: 'compelChangePassword',
	data() {
		// check password
		let pass = (rule, value, callback) => {
			let level = this.company_password_strength
			var uppercasePattern = PasswordStrengthRegExp.uppercasePattern
			var lowercasePattern = PasswordStrengthRegExp.lowercasePattern
			var sysbolPattern = PasswordStrengthRegExp.sysbolPattern
			var uppercaseRes = uppercasePattern.test(value)
			var lowercaseRes = lowercasePattern.test(value)
			var sysbolRes = sysbolPattern.test(value)
			if (value.length) {
				if (level === 1) {
					if (value.length >= 6 && ((lowercaseRes && uppercaseRes) || (lowercaseRes && sysbolRes) || (uppercaseRes && sysbolRes))) {
						callback()
					} else {
						this.show_password_warning = false
						callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level1_msg)))
					}
				} else if (level === 2) {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback()
					} else {
						this.show_password_warning = false
						callback(new Error(this.$gettext(PasswordStrengthRegExpCallback.level2_msg)))
					}
				} else {
					// level为0
					callback()
				}
			} else {
				callback(new Error(this.$gettext('Please enter your password!')))
			}
			if (this.formData.checkPass !== '') {
				this.$refs.passForm.validateField('checkPass')
			}
		}
		let checkPass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$gettext('Please enter your password again!')))
			} else if (value !== this.formData.pass) {
				callback(new Error(this.$gettext('Two passwords are not consistent!')))
			} else {
				callback()
			}
		}
		return {
			loading: false,
			formData: {
				pass: '',
				checkPass: '',
			},
			rules: {
				pass: [{ validator: pass, trigger: 'change' }],
				checkPass: [{ validator: checkPass, trigger: 'change' }],
			},
			company_password_strength: this.$store.getters.team.setting.password_strength || 0,
			show_password_warning: this.$store.getters.team.setting.password_strength !== '0',
		}
	},

	methods: {
		// 确定提交修改密码
		onSubmitForm(formName) {
			let params = {
				data: {
					pwd: this.formData.pass,
				},
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$store.dispatch(STORE_CONST.ACCOUNT.COMPEL_CHANGE_PSWD, params).then((res) => {
						console.log(res, 'res')
						this.$store.dispatch(STORE_CONST.ACCOUNT.LOGOUT).then((res) => {
							this.$router.push('/login')
							this.$notify({
								message: this.$gettext('Modify password successfully,Please Re Login'),
								type: 'success',
							})
						})
					})
				} else {
					return false
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.container {
	height: 390px;
}

.login {
	.form-title {
		font-size: 20px;
		font-weight: bold;
		padding: 10px 0;
		margin-top: 20px;
		color: #000;
	}
	.el-form {
		width: 300px;
		margin: 10px auto 30px;

		.el-form-item {
			margin-bottom: 20px;

			.el-input__inner {
				height: 32px;
			}

			&.is-error {
				.el-input {
					.el-input__inner {
						border-color: #bfcbd9 !important;
					}
				}
			}
		}

		.form-control {
			font-size: 14px;
		}

		.btn {
			width: 100%;
			font-size: 16px;
			border-radius: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// compelChangePassword.vue?df738b5c